<h2 mat-dialog-title class="dialog-title">
  <i *ngIf="data.titleIcon" class="title-icon">{{ data.titleIcon }}</i>
  {{ data.title }}
</h2>
<hr />
<mat-dialog-content class="mat-typography">
  <div class="dialog-text">{{ data.text }}</div>
  <ng-container *ngIf="data.extraInfoTitle">
    <div class="extra-info-container">
      <span class="extra-info-title">{{ data.extraInfoTitle }}</span>
      <div
        class="extra-info-placeholder"
        *ngIf="data.extraInfoLabel && data.extraInfoContent"
      >
        <span class="extra-info-label">{{ data.extraInfoLabel }}:</span>
        <span class="extra-info-context">{{ data.extraInfoContent }}</span>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-button
    #btnNo
    color="transparent"
    css="no-button"
    mat-dialog-close
    cdkFocusInitial
    [text]="data.noText || 'Não'"
  >
  </app-button>
  <app-button
    [mat-dialog-close]="true"
    css="ml-2"
    (onClick)="ok()"
    [text]="data.yesText || 'Sim'"
  >
  </app-button>
</mat-dialog-actions>
